// import axios from "axios";

// const API = "https://opiniongames.net/api/super-admin";

// /* CREATE AXIOS INSTANCE */
// const axiosInstance = axios.create({
//   baseURL: API,
// });

// /* ADD TOKEN INTERCEPTOR */
// axiosInstance.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token"); // 👈 your token key
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

// /* APIs */

// export const addMatchQuestion = (data) =>
//   axiosInstance.post("/match_questions", data);

// export const getMatchQuestions = (match_id) =>
//   axiosInstance.get(`/get_match_questions?match_id=${match_id}`);

// export const updateDeleteMatchQuestion = (data) =>
//   axiosInstance.post("/update-delete-a-game-question", data);


import axios from "axios";

const API = "https://opiniongames.net/api/super-admin";

/* ================= AXIOS INSTANCE ================= */
const axiosInstance = axios.create({
  baseURL: API,
  headers: {
    "Content-Type": "application/json",
  },
});

/* ================= TOKEN INTERCEPTOR ================= */
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/* ================= ADD ================= */
export const addMatchQuestion = async (data) => {
  const res = await axiosInstance.post("/match_questions", data);
  return res.data;
};

/* ================= GET ================= */
export const getMatchQuestions = async (match_id) => {
  const res = await axiosInstance.get(
    `/get_match_questions?match_id=${match_id}`
  );
  return res.data;
};

/* ================= UPDATE / DELETE ================= */
export const updateDeleteMatchQuestion = async (data) => {
  const res = await axiosInstance.post(
    "/update-delete-a-game-question",
    data
  );
  return res.data;
};